import { useState, useEffect } from 'react';
import { useSubscriptionsStore } from '.';

function useSubscriptionCard(subscriptionId) {
    const store = useSubscriptionsStore();

    const [connectedSchedules, setConnectedSchedules] = useState(
        () => store.connectedSchedules[subscriptionId] || []
    );
    const [availableSchedules, setAvailableSchedules] = useState(
        () => store.availableSchedules[subscriptionId] || []
    );
    const [details, setDetails] = useState(
        () => store.subscriptionDetails[subscriptionId] || {}
    );

    // Fires only for this card when a schedule is added or removed
    useEffect(() => {
        setConnectedSchedules(store.connectedSchedules[subscriptionId] || []);
        setAvailableSchedules(store.availableSchedules[subscriptionId] || []);
    }, [store.cardSignals.get(subscriptionId)]);

    // Fires for all cards on a full subscription reload (initial load, unsubscribe)
    useEffect(() => {
        setConnectedSchedules(store.connectedSchedules[subscriptionId] || []);
        setAvailableSchedules(store.availableSchedules[subscriptionId] || []);
        setDetails(store.subscriptionDetails[subscriptionId] || {});
    }, [store.observed.subscriptions]);

    return { connectedSchedules, availableSchedules, details };
}

export default useSubscriptionCard;
